import CompanionSlide from './companionSlide'

const companionSlide = new CompanionSlide()
companionSlide.init()
